import { TextInput } from '@neo4j-ndl/react';
import type { Validation } from '@nx/stdlib';

import type { InstanceFormData } from '../entities/model';
import { BaseInstanceCreateSection } from './base-section';

type Props = {
  data: InstanceFormData;
  onDataChange: (data: Partial<InstanceFormData>) => void;
  validation: Validation<InstanceFormData> | null;
};

export const DetailsSection = ({ data, onDataChange, validation }: Props) => {
  const handleNameChange = (name: string) => {
    onDataChange({ name });
  };

  return (
    <BaseInstanceCreateSection title={<div className="flex justify-between">Instance details</div>}>
      <div className="@sm:grid-cols-2 grid grid-cols-1 gap-4">
        <TextInput
          isFluid
          value={data.name ?? ''}
          onChange={(e) => handleNameChange(e.target.value)}
          errorText={
            validation?.name?.message ??
            ((data.name ?? '').length > 30 ? 'Instance name must be at most 30 characters' : null)
          }
          label="Name"
          htmlAttributes={{
            // Need to have due to bug in ndl
            onKeyDown: (e: React.KeyboardEvent) => e.stopPropagation(),

            'data-testid': 'instance-name-input',
          }}
        />
      </div>
    </BaseInstanceCreateSection>
  );
};
